import { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

function detectLang() {
  const stored = localStorage.getItem("eleven_lang");
  if (stored === "de" || stored === "en") return stored;
  const nav = (navigator.language || navigator.userLanguage || "de").toLowerCase();
  return nav.startsWith("de") ? "de" : "en";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  const setLang = useCallback((l) => {
    localStorage.setItem("eleven_lang", l);
    setLangState(l);
    document.documentElement.lang = l;
  }, []);

  // t("deutscher Text", "english text")
  const t = useCallback((de, en) => (lang === "de" ? de : en), [lang]);
  // tt({de, en}) for backend bilingual objects
  const tt = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.de || obj.en || "";
    },
    [lang]
  );

  return <LangContext.Provider value={{ lang, setLang, t, tt }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
